import { Helmet } from 'react-helmet-async';

export const HomeStructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Plottie",
    "applicationCategory": "EntertainmentApplication",
    "operatingSystem": "Web",
    "description": "Erschaffe personalisierte Hörgeschichten für Kinder - perfekt für Kreativ-Tonies oder zum direkten Abspielen.",
    "offers": {
      "@type": "Offer",
      "price": "3.90",
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "127"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}; 